 import { Injectable } from '@angular/core';
import { GlobalConstants } from '../GlobalConstants ';

@Injectable({
  providedIn: 'root'
})
export class EndpointServiceService {

  public SERVER_URL = GlobalConstants.SERVER_URL;
  public DOC_API = GlobalConstants.DOC_API;

  public PNAC_APPID = 1605767792296;
  public POWERTECH_ORGID = 1618396720966;
  public NCS_ORGID = 1608640805201;
  public RAYS_ORGID = 1618403768494;
  public MnM_Group_Of_Companies = 1620111233528;
  public Airtel_ANG = 1638255263104;
  public CreatEV_Solutions = 1666173296998;

  //Common start
  public AUTH = GlobalConstants.SERVER_URL + "/Auth";
  public DOC = GlobalConstants.SERVER_URL + "/Doc";
  public DATABASE = GlobalConstants.SERVER_URL + "/database";
  public APPINFO = GlobalConstants.SERVER_URL + "/appinfo";
  public APPCONFIG = GlobalConstants.SERVER_URL + "/appconfig";
  public ERROR_LOG = GlobalConstants.SERVER_URL + "/errorlog";
  public ORGNAZTION = GlobalConstants.SERVER_URL + "/Org";
  //common end

   public ACCESSLOG = GlobalConstants.SERVER_URL + "/AccessLog";
   public APPUSER = GlobalConstants.SERVER_URL + "/AppUser";
   public APPOINTMENT = GlobalConstants.SERVER_URL + "/Appointment";
   public GATE = GlobalConstants.SERVER_URL + "/Gate";
   public UNIT = GlobalConstants.SERVER_URL + "/Unit";
   public VISITORMANAGEMENT = GlobalConstants.SERVER_URL + "/VisitorManagement";
   public EMPLOYEEMANAGEMENT = GlobalConstants.SERVER_URL + "/EmployeeManagement";
   public ATTENDANCE = GlobalConstants.SERVER_URL + "/Attendance";
   public DEPARTMENT = GlobalConstants.SERVER_URL + "/Department";
   public MENU = GlobalConstants.SERVER_URL + "/Menu";
   public MESSAGE = GlobalConstants.SERVER_URL + "/MessagePhone";
   public MOBILECONTACT = GlobalConstants.SERVER_URL + "/MobileContact";
   public MOBILELOCATION = GlobalConstants.SERVER_URL + "/MobileLocation";
   public PUBLIC = GlobalConstants.SERVER_URL + "/api/pub";
   public CALLLOGS = GlobalConstants.SERVER_URL + "/CallLogs";
   public MOBILEGALLERY = GlobalConstants.SERVER_URL + "/MobileGallery";
   public SHIFT = GlobalConstants.SERVER_URL + "/Shift";
   public EMPLOYEEQRCODE = GlobalConstants.SERVER_URL + "/EmployeeQRCode";
   public EVENT = GlobalConstants.SERVER_URL + "/Event";
   public EVENTACCESSLOG = GlobalConstants.SERVER_URL + "/EventLog";
   
   public getEndpoint(url: string, suburl: string) {
     return url + "/" + suburl;
   }
}
